function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getAction, postAction, putAction } from "@/api/manage";
import { mixinDevice } from '@/utils/mixin.js';
import moment from "moment";
import pick from "lodash.pick";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import JSearchSelectTag from '@/components/jeecg/JSearchSelectTag';
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import JCategorySelect from "@comp/jeecg/JCategorySelect";
import JUpload from '@/components/jeecg/JUpload';
import PhotoModal from "@/components/user/PhotoModal";
import EventPay from "./EventPay";
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";
export default {
  name: "EventApplyModal",
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag,
    JAreaLinkage: JAreaLinkage,
    JCategorySelect: JCategorySelect,
    JUpload: JUpload,
    PhotoModal: PhotoModal,
    EventPay: EventPay,
    JSearchSelectTag: JSearchSelectTag
  },
  data: function data() {
    return _defineProperty(_defineProperty({
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      eventId: "",
      eventCategory: "",
      eventInfo: {},
      canApplyMulti: true,
      //是否可以报名多项
      applyConfig: {},
      applyPrice: 0,
      //报名费用
      applyEventInfo: {}
    }, "eventCategory", ""), "validatorRules", {
      photo: {
        rules: [{
          required: true,
          message: "请上传证件照!"
        }]
      },
      realname: {
        rules: [{
          required: true,
          message: "请输入真实姓名!"
        }]
      },
      idcard: {
        rules: [{
          required: true,
          pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
          message: "请输入正确的身份证号码!"
        }]
      },
      // birthday: {
      //   initialValue: '1999-10-10',
      //   rules: [
      //     { required: true, message: "请输入生日!" },
      //     { validator: this.handleBirthdayCheck },
      //   ],
      //   validateTrigger: ["change", "blur"],
      //   validateFirst: true,
      // },
      grade: {
        rules: [{
          required: true,
          message: "请输入年级!"
        }]
      },
      schoolClass: {
        rules: [{
          required: false,
          message: "请输入班级!"
        }]
      },
      email: {
        rules: [{
          required: true,
          pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: "请输入正确的邮箱地址!"
        }]
      },
      teacherName: {
        rules: [{
          required: false,
          message: "请输入辅导老师姓名!"
        }]
      },
      teacherPhone: {
        rules: [{
          required: false,
          message: "请输入辅导老师手机号!",
          pattern: /^1[3456789]\d{9}$/
        }]
      },
      parentName: {
        rules: [{
          required: false,
          message: "请输入监护人姓名!"
        }]
      },
      parentPhone: {
        rules: [{
          required: false,
          message: "请输入监护人手机号!",
          pattern: /^1[3456789]\d{9}$/
        }]
      },
      sex: {
        initialValue: 1,
        rules: [{
          required: true,
          message: "请选择性别!"
        }]
      },
      school: {
        rules: [{
          required: true,
          message: "请填写在读学校!不可写校外机构名"
        }]
      },
      address: {
        rules: [{
          required: true,
          message: "请选择省市"
        }]
      },
      addressDetailed: {
        initialValue: '朱泾镇',
        rules: [{
          required: true,
          message: "请填写详细地址"
        }]
      },
      eventCategory: {
        rules: [{
          required: true,
          message: "请选择报名类别"
        }]
      }
    });
  },
  created: function created() {},
  methods: {
    // handleBirthdayCheck(rule, value, callback) {
    //   let birthday = this.form.getFieldValue("birthday");
    //   let idcard = this.form.getFieldValue("idcard");
    //   if (birthday === undefined) {
    //     callback(new Error("请选择生日"));
    //   }
    //   birthday = birthday.format("YYYYMMDD");
    //   console.log(birthday);
    //   if (value && !idcard.includes(birthday)) {
    //     callback(new Error("生日和身份证信息不一致"));
    //   }
    //   callback();
    // },
    checkNumber: function checkNumber(theObj) {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(theObj)) {
        return true;
      }
      return false;
    },
    open: function open(eventId, eventCategory) {
      var _this = this;
      if (!eventId) {
        this.$message.warning("参数错误");
      }
      this.getEventInfo(eventId);
      this.eventId = eventId;
      this.eventCategory = eventCategory;
      if (eventCategory) {
        this.canApplyMulti = false;
        this.$nextTick(function () {
          _this.form.setFieldsValue({
            eventCategory: eventCategory
          });
        });
        this.getMyApplyInfo(eventCategory);
      } else {
        // this.getEventInfo(eventId)
      }
      this.visible = true;
    },
    getEventInfo: function getEventInfo(eventId) {
      var _this2 = this;
      getAction('/teaching/teachingEvent/queryById', {
        id: eventId
      }).then(function (res) {
        if (res.success) {
          _this2.eventInfo = res.result;
          _this2.applyConfig = JSON.parse(_this2.eventInfo.applyConfig);
        } else {
          _this2.$message.warning("活动不存在");
        }
      });
    },
    getMyApplyInfo: function getMyApplyInfo(eventCategory) {
      var _this3 = this;
      getAction("/teaching/teachingEventApply/myApplyByEventId", {
        eventId: this.eventId,
        eventCategory: eventCategory
      }).then(function (res) {
        if (res.success) {
          _this3.applyEventInfo = res.result;
          _this3.$nextTick(function () {
            _this3.form.setFieldsValue(pick(_this3.applyEventInfo, "realname", "idcard", "grade", "schoolClass", "teacherName", "teacherPhone", "parentName", "parentPhone", "sex", "school", "address", "addressDetailed", "teammateNames", "teammateIdcards", "teammateGrades", "eventCategory", "email"));
            // this.form.setFieldsValue({
            //   birthday: moment(this.applyEventInfo.birthday, "YYYY-MM-DD"),
            // });
          });
        } else {}
      });
    },
    onEventCategoryChange: function onEventCategoryChange(value, label, data) {
      this.model.eventCategory = value;
      this.applyPrice = 0;
      for (var i in data) {
        if (data[i].customValue) {
          var config = JSON.parse(data[i].customValue);
          if (config.baseConfig && config.baseConfig.applyPrice) {
            console.log(label[i], config.baseConfig.applyPrice);
            var price = parseFloat(config.baseConfig.applyPrice);
            this.applyPrice += price;
          }
        }
      }
    },
    photoChange: function photoChange(key, photoId) {
      var _this4 = this;
      putAction("/teaching/user/modify", {
        photo: photoId
      }).then(function (res) {
        if (res.success) {
          //this.getUserInfo();
          _this4.$info({
            title: "提示",
            content: "修改证件照将在3个工作日内审核完毕",
            onOk: function onOk() {}
          });
        } else {
          _this4.$message.warning(res.message);
        }
      }).finally(function () {
        _this4.confirmLoading = false;
      });
    },
    handleOk: function handleOk() {
      var _this5 = this;
      var that = this;
      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          if (!values.birthday) {
            values.birthday = "";
          } else {
            values.birthday = values.birthday.format("YYYY-MM-DD");
          }
          values.id = _this5.applyEventInfo.id;
          values.eventId = _this5.eventId;
          postAction("/teaching/teachingEventApply/apply", values).then(function (res) {
            if (res.success) {
              if (that.applyPrice > 0) {
                //创建订单
                var orderInfo = res.result;
                if (orderInfo) {
                  that.$refs.eventPay.open(orderInfo);
                } else {
                  that.$message.success(res.message);
                  //this.$router.push({path: "/user/event"})
                }
              } else {
                that.$message.success(res.message);
                //this.$router.push({path: "/user/event"})
                that.handleCancel();
              }
              that.visible = false;
              that.confirmLoading = false;
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    payOk: function payOk() {
      this.$router.push({
        path: "/user/event"
      });
      this.handleCancel();
    },
    payError: function payError() {
      this.confirmLoading = false;
    },
    handleCancel: function handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.form.resetFields();
    }
  }
};